import d from "./colors.js";
import { hsl2rgb as I, hsv2rgb as M } from "./convert.js";
const f = "^\\s*", c = "\\s*$", h = "\\s*((\\.\\d+)|(\\d+(\\.\\d*)?))%\\s*", u = "\\s*((\\.\\d+)|(\\d+(\\.\\d*)?))\\s*", o = "([0-9A-Fa-f])", g = "([0-9A-Fa-f]{2})", v = new RegExp(`${f}hsl\\s*\\(${u},${h},${h}\\)${c}`), A = new RegExp(`${f}hsv\\s*\\(${u},${h},${h}\\)${c}`), y = new RegExp(`${f}hsla\\s*\\(${u},${h},${h},${u}\\)${c}`), b = new RegExp(`${f}hsva\\s*\\(${u},${h},${h},${u}\\)${c}`), N = new RegExp(`${f}rgb\\s*\\(${u},${u},${u}\\)${c}`), H = new RegExp(`${f}rgba\\s*\\(${u},${u},${u},${u}\\)${c}`), F = new RegExp(`${f}#${o}${o}${o}${c}`), z = new RegExp(`${f}#${g}${g}${g}${c}`), D = new RegExp(`${f}#${o}${o}${o}${o}${c}`), P = new RegExp(`${f}#${g}${g}${g}${g}${c}`);
function i(n) {
  return parseInt(n, 16);
}
function S(n) {
  try {
    let e;
    if (e = y.exec(n))
      return [
        l(e[1]),
        a(e[5]),
        a(e[9]),
        p(e[13])
      ];
    if (e = v.exec(n))
      return [l(e[1]), a(e[5]), a(e[9]), 1];
    throw new Error(`[seemly/hsla]: Invalid color value ${n}.`);
  } catch (e) {
    throw e;
  }
}
function j(n) {
  try {
    let e;
    if (e = b.exec(n))
      return [
        l(e[1]),
        a(e[5]),
        a(e[9]),
        p(e[13])
      ];
    if (e = A.exec(n))
      return [l(e[1]), a(e[5]), a(e[9]), 1];
    throw new Error(`[seemly/hsva]: Invalid color value ${n}.`);
  } catch (e) {
    throw e;
  }
}
function R(n) {
  try {
    let e;
    if (e = z.exec(n))
      return [i(e[1]), i(e[2]), i(e[3]), 1];
    if (e = N.exec(n))
      return [s(e[1]), s(e[5]), s(e[9]), 1];
    if (e = H.exec(n))
      return [
        s(e[1]),
        s(e[5]),
        s(e[9]),
        p(e[13])
      ];
    if (e = F.exec(n))
      return [
        i(e[1] + e[1]),
        i(e[2] + e[2]),
        i(e[3] + e[3]),
        1
      ];
    if (e = P.exec(n))
      return [
        i(e[1]),
        i(e[2]),
        i(e[3]),
        p(i(e[4]) / 255)
      ];
    if (e = D.exec(n))
      return [
        i(e[1] + e[1]),
        i(e[2] + e[2]),
        i(e[3] + e[3]),
        p(i(e[4] + e[4]) / 255)
      ];
    if (n in d)
      return R(d[n]);
    if (v.test(n) || y.test(n)) {
      const [t, r, $, x] = S(n);
      return [...I(t, r, $), x];
    } else if (A.test(n) || b.test(n)) {
      const [t, r, $, x] = j(n);
      return [...M(t, r, $), x];
    }
    throw new Error(`[seemly/rgba]: Invalid color value ${n}.`);
  } catch (e) {
    throw e;
  }
}
function q(n) {
  return n > 1 ? 1 : n < 0 ? 0 : n;
}
function E(n, e, t, r) {
  return `rgba(${s(n)}, ${s(e)}, ${s(t)}, ${q(r)})`;
}
function m(n, e, t, r, $) {
  return s((n * e * (1 - r) + t * r) / $);
}
function K(n, e) {
  Array.isArray(n) || (n = R(n)), Array.isArray(e) || (e = R(e));
  const t = n[3], r = e[3], $ = p(t + r - t * r);
  return E(m(n[0], t, e[0], r, $), m(n[1], t, e[1], r, $), m(n[2], t, e[2], r, $), $);
}
function L(n, e) {
  const [t, r, $, x = 1] = Array.isArray(n) ? n : R(n);
  return typeof e.alpha == "number" ? E(t, r, $, e.alpha) : E(t, r, $, x);
}
function O(n, e) {
  const [t, r, $, x = 1] = Array.isArray(n) ? n : R(n), { lightness: w = 1, alpha: C = 1 } = e;
  return B([t * w, r * w, $ * w, x * C]);
}
function p(n) {
  const e = Math.round(Number(n) * 100) / 100;
  return e > 1 ? 1 : e < 0 ? 0 : e;
}
function l(n) {
  const e = Math.round(Number(n));
  return e >= 360 || e < 0 ? 0 : e;
}
function s(n) {
  const e = Math.round(Number(n));
  return e > 255 ? 255 : e < 0 ? 0 : e;
}
function a(n) {
  const e = Math.round(Number(n));
  return e > 100 ? 100 : e < 0 ? 0 : e;
}
function B(n) {
  const [e, t, r] = n;
  return 3 in n ? `rgba(${s(e)}, ${s(t)}, ${s(r)}, ${p(n[3])})` : `rgba(${s(e)}, ${s(t)}, ${s(r)}, 1)`;
}
export {
  L as changeColor,
  K as composite,
  I as hsl2rgb,
  S as hsla,
  M as hsv2rgb,
  j as hsva,
  R as rgba,
  p as roundAlpha,
  s as roundChannel,
  l as roundDeg,
  a as roundPercent,
  O as scaleColor,
  B as toRgbaString
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/seemly@0.3.10/~/seemly/es/color/index.js
// module id = 62
// module chunks = 41